import css from './empty-placeholder.module.scss';
import { ReactComponent as EmptyPlaceholderIcon } from 'src/assets/empty-search-icon.svg';

export default function EmptyPlaceholder({ title }: Readonly<{ title: string }>) {
  return (
    <div className={css.emptySearchPlaceholder}>
      <div className={css.textGroup}>
        <p>{title}</p>
        <ul>
          <li>Перевірте, що всі слова написані правильно.</li>
          <li>Спробуйте використати інші ключові слова.</li>
        </ul>
      </div>
      <EmptyPlaceholderIcon />
    </div>
  );
}
